<div class="container-fluid site-map">
    <div class="row breadcrumb-wrapper">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <app-breadcrumb *ngIf="showBreadCrumb"></app-breadcrumb>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row dealer-review-row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="container">
                <h1 class="page-sub-title cv-text-dark mb-4 mt-4">Site Map</h1>
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
                        <div class="item-wrapper">
                            <h3 class="item-title">Pages</h3>
                            <ul class="item-list">
                              <li><a [routerLink]="''">Home</a></li>
                              <li><a [routerLink]="'/compare'">Compare</a></li>
                              <li><a href="https://tataok.tatamotors.com" target="_blank" rel="noopener noreferrer">Exchange</a></li>
                              <li><a [routerLink]="'/help'">Help</a></li>
                              <li><a [routerLink]="'/customer-stories'">Customer Stories</a></li>
                              <!-- <li><a [routerLink]="'/offers'">Offers</a></li> -->
                              <li><a [routerLink]="'/find-dealer'">Dealer Outlet Locator</a></li>
                              <li><a (click)="callConfigurator()" [routerLink]="'/configurator-home'">Build Your Own Vehicle</a></li>
                              <li class="divider"></li>
                              <li><a [routerLink]="'/terms-conditions'">Terms & Conditions</a></li>
                              <li><a [routerLink]="'/privacy-policy'">Privacy policy</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-8 col-lg-9 col-xl-9">
                        <div class="item-wrapper">
                            <h3 class="item-sub-title">Trucks</h3>
                            <div class="row row-cols-2 row-cols-md-3 row-cols-lg-3 row-cols-xl-5">
                                <div class="col"  *ngFor="let truck of TruckList?.data">
                                    <h4 class="list-title">{{truck.name}}</h4>
                                    <ul class="item-list">
                                        <li *ngFor="let subMenu of truck.ppl">
                                            <a [routerLink]="gotoPath(truck.link,subMenu.display_ppl
                                            )">{{ subMenu.actual_ppl}}</a>
                                        </li>
                                    </ul>
                                </div>


                            </div>
                        </div>
                        <div class="item-wrapper">
                            <h3 class="item-sub-title">Buses & Vans</h3>
                            <div class="row row-cols-3 row-cols-md-3 row-cols-lg-3">
                                <div class="col"  *ngFor="let bus of BusesList?.data">
                                    <h4 class="list-title">{{bus.name}}</h4>
                                    <ul class="item-list">
                                        <li *ngFor="let subMenu of bus.ppl">
                                            <a [routerLink]="gotoPath(bus.link,subMenu.display_ppl
                                            )">{{ subMenu.actual_ppl}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="item-wrapper">
                            <h3 class="item-sub-title">SCV & Pickups</h3>
                            <div class="row row-cols-sm-2 row-cols-md-2 row-cols-lg-2">
                                <div class="col"  *ngFor="let scv of SCVList?.data">
                                    <h4 class="list-title">{{scv.name}}</h4>
                                    <ul class="item-list">
                                        <li *ngFor="let subMenu of scv.ppl">
                                            <a [routerLink]="gotoPath(scv.link,subMenu.display_ppl
                                            )">{{ subMenu.actual_ppl}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
